<template>
<div class="content starting">
    <div class="login boxLogin">
        <b-row>
             <b-col class="box" lg="12">
                <img src="../assets/logo_bodytone_top_main.png" alt="Bodytone">
            </b-col>
        </b-row>
        <b-row>  
            <b-col lg="12">
                <div class="bylogin" v-if="showView ==='login'">
                    <h3>{{ $t("messages.signin") }}</h3>
                    <div class="form-group">
                        <b-form-input type="text" v-bind:placeholder="$t('messages.placeholder.email')" v-model="email"></b-form-input>
                    </div>
                    <div class="form-group">
                        <b-form-input type="password" v-bind:placeholder="$t('messages.placeholder.password')" v-model="password"></b-form-input>
                    </div>
                    <button class="remember" @click="showView ='remember'">{{ $t("messages.forgetPassword") }}</button>
                    <button class="enter" v-on:click="signIn">{{ $t("messages.enter") }}</button>
                    <hr>
                    <p style="#ffffff">{{ $t("messages.createAccountInfo") }} <b-button size="sm" variant="link" v-on:click="showView ='signup'">{{ $t("messages.createAccount") }}</b-button>
                    </p>
                </div>
                <div v-else-if="showView ==='remember'">
                    <h3>{{ $t("messages.passwordRecovery") }}</h3>
                    <div class="form-group">
                        <b-form-input type="text" v-bind:placeholder="$t('messages.placeholder.email')" v-model="rememberEmail"></b-form-input>
                    </div>
                    <button class="remember" @click="showView ='login'">Cancel</button>
                    <button v-on:click="rememberPassword" :disabled="rememberEmail.length == 0">{{ $t("messages.request") }}</button>
                </div>
                <sign-up v-else-if="showView ==='signup'" v-bind:actionCodeSettings="actionCodeSettings" v-on:setLogin="showView ='login'" v-on:onSuccess="onSuccess" v-on:onError="onError"></sign-up>
                <b-row>
                    <a href="https://bodytone.eu/es/aviso-de-privacidad/" target="_blank" class="footer-link">{{ $t("messages.legal") }}</a>
                    <b-navbar-nav>
                        <b-nav-item-dropdown>
                            <template slot="button-content">
                                <em> {{ currentLanguage }} </em>
                            </template>
                            <b-dropdown-item v-for="(lang, i) in languages" :key="`Lang${i}`" :value="lang.key" @click="$i18n.locale = lang.code">{{ lang.name }}</b-dropdown-item>
                        </b-nav-item-dropdown>
                    </b-navbar-nav>
              
                </b-row>
               
            </b-col>
        </b-row>
    
    </div>
    <cookie-law theme="blood-orange" :buttonText="$t('messages.accept')" buttonClass="button">
    <div slot="message">
        {{ $t("messages.cookieText") }} <router-link style="color:#ffffff;margin-left:5px" to="legal">+ Info </router-link>
    </div>
    </cookie-law>
</div>
</template>

<script>
const fb = require('../firebaseConfig.js')
import Vue from 'vue'
import SignUp from './SignUp.vue'
import { mapState } from 'vuex'
import VueNotifications from 'vue-notifications'
import CookieLaw from 'vue-cookie-law'

export default {
    name: 'login',
    components:{
        SignUp,
        CookieLaw
    },
    props:{
        isNew : null
    },
    computed: {
        currentLanguage: function () {
            var index =  this.languages.map((o) => o.code).indexOf(this.$i18n.locale);
            return this.languages[index].name;
        },
        ...mapState(['languages', 'actionCodeSettings'])
    },
    data: function () {
        return {
            email: '',
            sendEmail: '',
            password: '',
            rememberEmail: '',
            showView: 'login'
        }
    },
    created() {
        if(this.isNew && this.isNew === true){
            this.showView = 'signup'
        }
        if (fb.auth.isSignInWithEmailLink(window.location.href)) {
            var email = window.localStorage.getItem('emailForSignIn');
            if (!email) {
                email = window.prompt('Please provide your email for confirmation');
            }
            // The client SDK will parse the code from the link for you.
            fb.auth.signInWithEmailLink(email, window.location.href)
                .then((current) => {
                    window.localStorage.removeItem('emailForSignIn');
                    this.$store.commit('setCurrentUser', current.user)
                    this.$store.dispatch('fetchUserData')
                    this.$router.replace('/dashboard/#/globaldata')
                })
                .catch( (err) => {
                    this.onError(err.message);
                });
        }
    },
    methods: {
        signIn: function () {
            fb.auth.signInWithEmailAndPassword(this.email, this.password).then(
                (current) => {
                    if (current.user.emailVerified === false) {
                        this.onSuccess(this.$t("messages.verifyEmail"));
                    } else {
                        this.$store.commit('setCurrentUser', current.user)
                        //this.$store.dispatch('fetchUserData')
                          this.$store.dispatch("fetchUserData").then(user => {
                            if(!user.profileComplete || user.profileComplete === false){
                               // this.$router.replace('/profile')
                                this.$router.push({ path: 'profile', query: { profile: 'new' } })
                            } else {
                                this.$router.replace('/dashboard')  
                            }
                         
                            }, error => {
                                console.error('No user data')
                            })
                    }
                },
                (err) => {
                   this.onError(err)
                }
            );
        },
        signInByEmail: function () {
            fb.auth.sendSignInLinkToEmail(this.sendEmail, this.actionCodeSettings)
                .then(() => {
                    this.onSuccess(this.$t("messages.requestSuccess"));
                    window.localStorage.setItem('emailForSignIn', this.sendEmail);
                })
                .catch( (err) => {
                    this.onError(err.message);
                });
        },
        rememberPassword: function () {
            fb.auth.sendPasswordResetEmail(this.rememberEmail, this.actionCodeSettings).then( (result) => {
                this.onSuccess(this.$t("messages.requestSuccess"));
            }).catch( (err) => {
                this.onError(err.message);
            });
        },
        onSuccess: function (msg) {
            this.showSuccessMsg({message: msg})
        },
        onError: function (msg) {
            this.showErrorMsg({message: msg})
        }
    },
    notifications: {
        showErrorMsg: { 
            title: 'Operation Failed',
            message: 'Failed to authenticate',
            type: 'error',
        },
        showSuccessMsg: { 
            title: 'Signin',
            message: 'Operation success',
            type: 'success',
            duration: 8000
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue